import React from 'react';
import ReactHtmlParser from "react-html-parser";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { newsActions } from '../../store/newsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';

import ErrorIcon from '../../img/icons/BBiconsErrorNotice';
import WarningIcon from '../../img/icons/BBiconsWarningNotice';
import SuccessIcon from '../../img/icons/BBiconsSuccesNotice';
import InfoIcon from '../../img/icons/BBiconsInfoNotice';

import 'react-toastify/dist/ReactToastify.css';
import './toast.scss';

class ToastContent extends React.Component {
    render() {
        return (
            <div className={`toast-message`} onClick={_ => this.onNotificationClick(this.props.notification)}>
                <div className="left">
                    {this.getIcon(this.props.notification)}
                </div>
                <div className="right">
                    {this.props.notification.newsId ? <>
                        <span className="news-header">
                            {ReactHtmlParser(this.urlFormat(this.props.notification.header))}
                        </span>
                        <br/>
                        <span>
                            {ReactHtmlParser(this.urlFormat(this.props.notification.shortText))}
                        </span>
                        <Link className="link-internal" to={`/news/${this.props.notification.newsId}`}>{this.props.translate("News.ReadMore")}</Link>
                    </> : <span>
                        {ReactHtmlParser(this.urlFormat(this.props.notification.description))}
                    </span>}
                </div>
            </div>
        );
    }

    getIcon = (notification) => {
        if (isNullOrUndefined(notification.color))
            return null;
        switch (notification.color.toLowerCase()) {
            case "success": return <SuccessIcon style={{ fill: '#00c59e' }} />;
            case "error": return <ErrorIcon style={{ fill: '#e74360' }} />;
            case "warn": return <WarningIcon style={{ fill: '#f5b31c' }} />;
            case "info": return <InfoIcon style={{ fill: '#61b4e4' }} />;
            default: return null;
        }

    }

    urlFormat = (description) => {
        if(isNullOrUndefined(description))
            return null;
        if (description.match('link-internal') && localStorage.locales_url_format === 'normal')
            return description.replace('link-internal', 'link-internal is-normal');
        return description;
    }

    onNotificationClick(notification) {
        if (notification.type === "notification") {
            if (this.isNotificationClickable(notification)) {
                const guid = notification.description.match(/guid="([a-fA-F0-9-]+)"/);
                if (guid) {
                    window.open(this.props.generatePdfLink(guid[1]), '_blank');
                    this.props.updateNotificationsStatus(2, notification.id);
                }
                else {
                    const reqId = notification.description.match(/req-id="([0-9]+)"/);
                    if (reqId) {
                        window.open(this.props.generateMlExportLink(reqId[1]), '_blank');
                        this.props.updateNotificationsStatus(2, notification.id);
                    } else {
                        const exportId = notification.description.match(/export-id="([0-9]+)"/);
                        if (exportId) {
                            window.open(this.props.generateExportLink(exportId[1]), '_blank');
                            this.props.updateNotificationsStatus(2, notification.id);
                        }
                        else {
                            const link = notification.description.match(/link-to="(.+)"/);
                            if (link) {
                                this.props.updateNotificationsStatus(2, notification.id);
                                this.props.history.push(link[1]);
                            }
                        }
                    }
                }
            }
        } else if (notification.newsId) {
            this.props.history.push(`/news/${notification.newsId}`);
        }
    }

    isNotificationClickable(notification) {
        return notification.description.indexOf('link-type="get-pdf"') !== -1
            || notification.description.indexOf('link-type="get-ml"') !== -1
            || notification.description.indexOf('link-to="') !== -1
            || notification.description.indexOf('link-type="get-export"') !== -1;
    }
}

export default withLocalize(withRouter(connect(state => state.news, dispatch => bindActionCreators(newsActions, dispatch))(ToastContent)))